// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__lxpN9","item":"PaymentsMobile_item__2ZgXu","label":"PaymentsMobile_label__21_W3","amount":"PaymentsMobile_amount__11DIK"};